import { PUNTO } from '../actions/types';

const initialState = {
    listado_productos: [],
    listado_servicios: [],
    listado_comandas: [],
    listado_medicos: [],
    listado_medicos_externos: [],
    listado_paquetes: []
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case PUNTO.BUSCAR_PRODUCTOS:
            return {
                ...state,
                listado_productos: payload
            };

        case PUNTO.BUSCAR_SERVICIOS:
            return {
                ...state,
                listado_servicios: payload
            };

        case PUNTO.BUSCAR_COMANDAS:
            return {
                ...state,
                listado_comandas: payload
            };

        case PUNTO.BUSCAR_MEDICOS:
            return {
                ...state,
                listado_medicos: payload
            };

        case PUNTO.BUSCAR_MEDICOS_EXTERNOS:
            return {
                ...state,
                listado_medicos_externos: payload
            };

        case PUNTO.BUSCAR_PAQUETES:
            return {
                ...state,
                listado_paquetes: payload
            };

        default:
            return state;
    }
}